import { DiscountFormField } from '../types';

function timestampToPDTString(timestamp: number): string {
  const date = new Date(timestamp * 1000);

  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Los_Angeles',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });

  const parts = formatter.formatToParts(date);
  const get = (type: string) => parts.find(p => p.type === type)?.value ?? '';

  return `${get('year')}-${get('month')}-${get('day')} ${get('hour')}:00:00`;
}

export const discountFormAdapter = ({
  [DiscountFormField.Name]: name,
  [DiscountFormField.StartTimestamp]: start_date,
  [DiscountFormField.EndTimestamp]: end_date,
  [DiscountFormField.DiscountValue]: amount_percent,
  [DiscountFormField.Audience]: audience,
  [DiscountFormField.AppliesToCategory]: applies_to_category,
  [DiscountFormField.AppliesToProduct]: applies_to_product,
}) => ({
  name,
  start_date: timestampToPDTString(start_date),
  end_date: timestampToPDTString(end_date),
  amount_percent,
  appliesto:
    applies_to_category === 'subscriptions' ? 'any_tier' : applies_to_product,
  audience,
});
